import { useState } from 'react';
import TenantTable from './TenantTable';
import TenantForm from './TenantForm';

const MODES = {
    LIST: 1,
    EDIT: 2,
    CREATE: 3,
};

const TenantManager = () => {
  const [mode, setMode] = useState(MODES.LIST);
  const [selectedTenant, setSelectedTenant] = useState(null);

    return (
        <>
            {mode === MODES.LIST && (
                <TenantTable
                    onEdit={(cust) => {
                        setSelectedTenant(cust);
                        setMode(MODES.EDIT);
                    }}
                    onCreate={() => {
                        setSelectedTenant(null);
                        setMode(MODES.CREATE);
                    }}
                />
            )}

            {(mode === MODES.EDIT || mode === MODES.CREATE) && (
                <TenantForm
                    tenant={selectedTenant}
                    onSuccess={() => setMode(MODES.LIST)}
                    onCancel={() => setMode(MODES.LIST)}
                />
            )}
        </>
    );
};

export default TenantManager;